(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slimline-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const videoButton = event.target.closest('[data-slimline-size-guide-video]');
    if (videoButton) {
      const iframe = document.createElement('iframe');
      iframe.src = videoButton.dataset.slimlineSizeGuideVideo;
      iframe.title = videoButton.getAttribute('aria-label') || '';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      videoButton.replaceWith(iframe);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
